<template>
  <div class="allOrder" :style="listHeight">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div>
            <van-row @click="detail(item.ordersn)">
              <van-col span="24" class="title">
                <img
                  src="../../../assets/accountAgent/order/order_icon.png"
                  alt=""
                />
                代运营订单
                <span v-if="item.status == 10">待付款</span>
                <!-- <span v-if="item.status == 15">支付中</span> -->
                <span v-if="item.status == 15 || item.status == 20"
                  >待签署合同</span
                >
                <!-- <span v-if="item.status == 25">合同审核中</span> -->
                <span v-if="item.status == 25 || item.status == 28"
                  >待发货</span
                >
                <span v-if="item.status == 30">待收货</span>
                <!-- <span v-if="item.status == 40">已收货</span> -->
                <span v-if="item.status == 40 || item.status == 50"
                  >已完成</span
                >
                <span v-if="item.status == -10 || item.status == -20"
                  >已取消</span
                >
                <!-- <span v-if="item.status == -20">平台关闭</span> -->
              </van-col>
              <van-col span="24" class="phone_info">手机数量 1台</van-col>
              <van-col span="24" class="time">
                下单时间 {{ item.created_at }}
              </van-col>
              <van-col span="24" class="money">
                实付款<span class="num">￥<span>2000</span>.00</span>
              </van-col>
              <!-- <van-col span="24" class="tips" v-if="index == 0">
                红包补贴金额已累计：¥467.00
              </van-col> -->
            </van-row>
            <van-row>
              <van-col span="24" class="btns">
                <btn
                  :btntext="'取消订单'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 10"
                  @btnClick="cancle(item)"
                />
                <btn
                  :btntext="'申请退款'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 15 || item.status == 20"
                  @btnClick="refund(item)"
                />
                <btn
                  :btntext="'查看协议'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status > 20"
                  @btnClick="seeSinature(item)"
                />
                <btn
                  :btntext="'联系客服'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  @btnClick="contract"
                />
                <btn
                  :btntext="'申请退还'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 40 || item.status == 50"
                  @btnClick="refundPhone(item)"
                />
                <!-- <btn
                  :btntext="'删除订单'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#666'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #eee'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == -10 || item.status == -20"
                  @btnClick="delect(item)"
                /> -->
                <btn
                  :btntext="'立即付款'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#F9591B'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #F9591B'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 10"
                  @btnClick="Pay(item)"
                />
                <btn
                  :btntext="'去签署'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#F9591B'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #F9591B'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 15 || item.status == 20"
                  @btnClick="toSign(item)"
                />
                <btn
                  :btntext="'确认收货'"
                  :btnwidth="'8.4rem'"
                  :height="'3.2rem'"
                  :bgcolor="'#fff'"
                  :borderradius="'1.6rem'"
                  :btncolor="'#F9591B'"
                  :fontsize="'1.5rem'"
                  :btnborder="'solid 0.1rem #F9591B'"
                  :btnmargin="'1.2rem 0 0 1.2rem'"
                  v-if="item.status == 30"
                  @btnClick="settle(item)"
                />
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="../../../assets/accountAgent/my/no_info.png" />
        <p class="tip">暂无订单</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="../../../assets/accountAgent/common/loading.gif" />
    </div>
    <a ref="phone" href="tel:4000571671"></a>
  </div>
</template>
<script>
import btn from "../components/button.vue";
import dsbridge from "dsbridge";
export default {
  components: {
    btn,
  },
  props: {
    orderStyle: {
      type: String,
      detault: "0",
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      listHeight: {
        height: document.body.clientHeight - 88 + "px",
        padding: "4.4rem 1.2rem 0",
      },
      hasList: true,
      facility: "",
      // currentOrderSn: "",
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
      //    setTimeout(() => {
      //      this.$toast('刷新成功');
      //      this.isLoading = false;
      //    }, 500);
    },
    getInfo() {
      this.$api
        .post("/investment/member/agent/order/list", {
          page: this.page,
          status: this.orderStyle,
        })
        .then((res) => {
          this.allList = res.total;
          //		        if(this.page = 1) {
          //		        	this.list = [];
          //		        }
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    detail(ordersn) {
      this.$router.push({
        path: "/accountAgent/detail",
        query: {
          ordersn: ordersn,
        },
      });
    },
    cancle(item) {
      this.$dialog
        .confirm({
          message: "您确定要取消该订单？",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "再想想",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("/order/member/order/cancel", { ordersn: item.ordersn })
            .then((res) => {
              setTimeout(() => {
                var length = this.page;
                this.list = [];
                this.page = 0;
                for (var j = 0; j < length; j++) {
                  this.page = j + 1;
                  this.getInfo();
                }
              }, 1000);
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        });
    },
    contract() {
      this.$dialog
        .confirm({
          message: "4000571671",
          confirmButtonText: "立即呼叫",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          // this.$refs.phone.click();
          // this.params("4000571671", "4000571671", "contract");

          let ua = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod|macintosh/i.test(ua) &&
            !this.$route.query.from
          ) {
            this.params("4000571671", "4000571671", "contract");
          } else {
            this.$refs.phone.click();
          }
        });
    },
    Pay(item) {
      // this.currentOrderSn = item.ordersn;
      sessionStorage.setItem("currentOrderSn", item.ordersn);
      let param = {
        actual_amount: item.amount,
        order_amount: item.amount,
        ordersn: item.ordersn,
        order_type: "surrogacy",
      };
      if (this.facility == "ios") {
        let that = this;
        dsbridge.call("goPay", JSON.stringify(param), function (v) {
          that.setPay(v);
        });
      } else if (this.facility == "android") {
        this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$router.push({
          //支付成功
          path: "/accountAgent/result",
          query: {
            type: 1,
            ordersn: sessionStorage.getItem("currentOrderSn"),
          },
        });
      }
      // else {
      //   this.$router.push({
      //     //支付失败
      //     path: "/accountAgent/detail",
      //     query: {
      //       ordersn: sessionStorage.getItem("currentOrderSn"),
      //       from: "pay",
      //     },
      //   });
      // }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    refund(item) {
      this.$dialog
        .confirm({
          message: "您确定要申请退款？",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("/investment/member/agent/order/after/add", {
              ordersn: item.ordersn,
            })
            .then((res) => {
              this.$toast("退款申请已提交成功");
              var length = this.page;
              this.list = [];
              this.page = 0;
              for (var j = 0; j < length; j++) {
                this.page = j + 1;
                this.getInfo();
              }
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        });
    },
    refundPhone(item) {
      this.$router.push({
        path: "/accountAgent/refund",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    toSign(item) {
      this.$router.push({
        path: "/accountAgent/signContract",
        query: {
          from: "h5",
          ordersn: item.ordersn,
        },
      });
    },
    seeSinature(item) {
      this.$router.push({
        path: "/accountAgent/electroniContract",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    settle(item) {
      this.$api
        .post("/order/member/order/settle", { ordersn: item.ordersn })
        .then((res) => {
          setTimeout(() => {
            var length = this.page;
            this.list = [];
            this.page = 0;
            for (var j = 0; j < length; j++) {
              this.page = j + 1;
              this.getInfo();
            }
          }, 1000);
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.allOrder {
  background-color: #f5f6f7;
  min-height: 100%;
  box-sizing: border-box;

  .empty {
    padding-top: 10rem;

    .emptyMsg {
      text-align: center;

      img {
        width: 22.1rem;
        display: inline-block;
      }

      .tip {
        color: #cccccc;
        font-size: 1.4rem;
        margin-top: 1.7rem;
        height: 2rem;
        line-height: 2rem;
      }
    }
  }

  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;

    img {
      width: 35%;
      margin-top: 50%;
    }
  }

  .van-pull-refresh {
    height: 100%;
    box-sizing: border-box;
    padding-top: 0.9rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .lists {
      min-height: 18.5rem;
      border-radius: 0.8rem;
      background: #fff;
      padding: 1.5rem 1.2rem;
      margin-bottom: 1rem;

      .title {
        color: #333;
        font-size: 1.5rem;
        text-align: left;
        height: 2.4rem;
        line-height: 2.4rem;

        img {
          width: 2rem;
          margin-right: 0.6rem;
          float: left;
          margin-top: 0.2rem;
        }

        span {
          color: #f9591b;
          font-size: 1.4rem;
          float: right;
        }
      }

      .phone_info {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 1.2rem;
      }

      .time {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 0.6rem;
      }

      .money {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 0.6rem;
        text-align: right;

        .num {
          color: #333;

          span {
            font-size: 1.7rem;
            font-weight: 700;
          }
        }
      }

      .tips {
        color: #333;
        font-size: 1.4rem;
        text-align: center;
        background: #f5f6f7;
        height: 2.9rem;
        line-height: 2.9rem;
        margin-top: 1.2rem;
      }

      .btns {
        text-align: right;
      }
    }
  }
}
</style>
<style lang="less">
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>